<template>
    <hts-drawer
        v-model="visible"
        :title="$t('labels.detailLocation')"
        no-reset
        size="large"
        @close="closeOverSide">
        <hts-card :title="$t('labels.location')">
            <div class="grid gap-4 grid-cols-1 sm:grid-cols-2">
                <hts-form-input
                    v-model="formData.address"
                    :label="$t('labels.address')"
                    :color="color"
                    readonly
                    name="address"
                    prop="address" />
                <hts-form-input
                    v-model="formData.locationName"
                    :label="$t('labels.locationName')"
                    :color="color"
                    readonly
                    name="locationName"
                    prop="locationName" />
                <hts-form-input
                    v-model="formData.latitudeAndLongitude"
                    :label="$t('labels.latitudeAndLongitude')"
                    :color="color"
                    readonly
                    name="latitudeAndLongitude"
                    prop="latitudeAndLongitude" />
            </div>
        </hts-card>

        <hts-card :title="$t('labels.position')">
            <hts-map-node
                class="min-h-[600px]"
                :center-position="dataPosition"
                center-marker
                :node-list="locationList" />
        </hts-card>
    </hts-drawer>
</template>
<script setup lang="ts">
import { $urlSystem } from '#imports'

const props = defineProps({
  color: {
    type: String
  }
})
const emits = defineEmits(['close', 'refreshTables'])

const visible = ref(false)

const rules = {
  address: 'required',
  locationName: 'required',
  latitudeAndLongitude: 'required'
}

const dataPosition = ref({
  lat: 0,
  lng: 0
})

const locationList = ref<Array<{ [key: string]: any }>>([])

const locationId = ref('')

const formData = ref<{ [key: string]: any }>({
  address: '',
  locationName: '',
  placeId: '',
  latitudeAndLongitude: '',
  lat: '',
  lng: '',
  newLocation: false
} as { [key: string]: any })

const open = (id: string) => {
  locationId.value = id
  visible.value = true
  getData()
  getAllNode()
}

const closeOverSide = () => {
  visible.value = false
}

const getData = async () => {
  const api = $urlSystem.node.location.detail
  const data: any = locationId.value ? await $api(api, { uriParams: { ID: locationId.value } }) : null
  const resData = data?.data?.value
  if (resData.success) {
    formData.value.address = resData.data.address
    formData.value.locationName = resData.data.locationName
    formData.value.placeId = resData.data.placeId
    formData.value.latitudeAndLongitude = `${resData.data.lat}, ${resData.data.lng}`
    formData.value.lat = resData.data.lat
    formData.value.lng = resData.data.lng
    formData.value.newLocation = resData.data.newLocation

    dataPosition.value = {
      lat: parseFloat(resData.data.lat),
      lng: parseFloat(resData.data.lng)
    }
  }
}

const getAllNode = async () => {
  const api = $urlSystem.node.location.getAll
  const data: any = await $api(api)
  const resData = data.data.value

  if (resData?.success) {
    const list = resData.data
    locationList.value = list.map((item: any) => ({
      position: {
        lat: parseFloat(item.lat),
        lng: parseFloat(item.lng)
      },
      isNewLocation: item.newLocation,
      icon: item.newLocation ? '/assets/new-location.png' : '/assets/location.png',
      title: item.locationName,
      placeId: item.placeId
    }))
  }
}

defineExpose({
  open
})
</script>
